<section class="container-fluid">

  <form novalidate autocomplete="off" name="editValueTranslationForm">
    <div class="row">
      <div class="col-sm-4 col-md-2"></div>
      <div class="col-sm-4 col-md-8">
        <div class="form-group ">
          <label class="lblCls">
            Option Code
          </label>
          <input type="text" kendoTextBox class="form-control" name="optionCode" [(ngModel)]="editValueTranslation.optionCode" />
        </div>
        <div class="form-group ">
          <label class="lblCls">
            Option Value Code
          </label>
          <input type="text" kendoTextBox class="form-control" name="optionValueCode" [(ngModel)]="editValueTranslation.optionValueCode" />
        </div>

        <div class="form-group ">
          <label class="lblCls">
            Option Value Translation
          </label>
          <input type="text" kendoTextBox class="form-control" name="optionValueTranslation" [(ngModel)]="editValueTranslation.optionValueTranslation" />
        </div>
        <div class="form-group">
          <label class="lblCls mr-2">
            Option Value Applicable Products
          </label>
          <kendo-multiselect [data]="productCode"
                             [(ngModel)]="value" name="optionValueApplicableProducts" [filterable]="true"(filterChange)="handleFilter($event)"></kendo-multiselect>
        </div>
        <div class="row">
          <div class="form-group">
            <div class="btn-group float-right" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="editValueTranslationToSave()">
                Update<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      [routerLink]="['../']">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4 col-md-2"></div>
    </div>
  </form>
</section>
